export default __webpack_public_path__ + "static/media/logo.5ea95c1c.png";